import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import API_BASE_URL from "../../config/api";
import "./certificate.css";

const MissingRegistration = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    usn: "",
    phone: "",
  });
  
  const [eventsSelected, setEventsSelected] = useState([]);
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const eventOptions = [
  "Binary Runes",
  "Arduino Alchemy",
  "BGMI Rush",
  "Project Nexus",
  "Arcane Quiz",
  "Runic Maze",
  "Zaun Race",
  "Construct Clash",
  "Hex Track",
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError(null);
  };

  const handleEventToggle = (eventName) => {
    setError(null);
    setEventsSelected(prev => {
      if (prev.includes(eventName)) {
        return prev.filter(e => e !== eventName);
      } else {
        return [...prev, eventName];
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.usn) {
      setError("Please fill out all required fields.");
      return;
    }

    if (eventsSelected.length === 0) {
      setError("Please select at least one event you participated in.");
      return;
    }

    // Join events logically into a single string to send to the backend
    const payload = {
      ...formData,
      event: eventsSelected.join(", ")
    };

    try {
      setLoading(true);
      setError(null);
      
      await axios.post(`${API_BASE_URL}/api/missing/submit`, payload);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || "Server error while submitting. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="cyber-bg certificate-page">
        <div className="certificate-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
          <div className="certificate-card success-card" style={{ maxWidth: '600px', textAlign: 'center' }}>
            <h2 className="success-title glaze-text" style={{ fontSize: '3rem' }}>SUBMITTED</h2>
            <p className="success-message" style={{ margin: '20px 0', fontSize: '1.2rem', color: 'rgba(255, 255, 255, 0.8)' }}>
              Your registration details have been sent to our Admin team. 
              Once verified successfully from our offline records or payment history, you'll be able to download your certificate.
            </p>
            <Link to="/certificate" className="cert-btn secondary" style={{ marginTop: '20px', display: 'inline-block' }}>
              RETURN TO PORTAL
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cyber-bg certificate-page">
      <div className="certificate-container">
        <div className="certificate-card fade-in" style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2 className="certificate-title glaze-text" style={{ fontSize: '2.5rem', textAlign: 'center' }}>CLAIM MISSING CERTIFICATE</h2>
          <p className="cert-subtitle" style={{ textAlign: 'center', marginBottom: '30px' }}>
            Did you participate but can't find your certificate?
            Submit your accurate details here to request admin manual verification.
          </p>

          {error && <div className="cert-alert cert-alert-error">{error}</div>}

          <form onSubmit={handleSubmit} className="cert-form">
            <div className="form-group mb-3">
              <label className="cert-label">FULL NAME *</label>
              <input 
                type="text" 
                name="name" 
                placeholder="e.g. Jinx" 
                value={formData.name} 
                onChange={handleChange} 
                required 
                className="cert-input"
              />
            </div>
            
            <div className="form-group mb-3">
              <label className="cert-label">EMAIL ADDRESS *</label>
              <input 
                type="email" 
                name="email" 
                placeholder="jinx@zaun.com" 
                value={formData.email} 
                onChange={handleChange} 
                required 
                className="cert-input"
              />
            </div>

            <div className="form-group mb-3">
              <label className="cert-label">USN / COLLEGE ID *</label>
              <input 
                type="text" 
                name="usn" 
                placeholder="1SI24CSXXX" 
                value={formData.usn} 
                onChange={handleChange} 
                required 
                className="cert-input"
              />
            </div>

            <div className="form-group mb-4">
              <label className="cert-label">PHONE NUMBER (Optional)</label>
              <input 
                type="tel" 
                name="phone" 
                placeholder="To contact you if needed" 
                value={formData.phone} 
                onChange={handleChange} 
                className="cert-input"
              />
            </div>

            <div className="form-group mb-4">
              <label className="cert-label" style={{ marginBottom: '15px', display: 'block' }}>
                SELECT EVENTS YOU PARTICIPATED IN *
              </label>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                gap: '15px'
              }}>
                {eventOptions.map(opt => (
                  <div 
                    key={opt} 
                    onClick={() => handleEventToggle(opt)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      background: eventsSelected.includes(opt) ? 'rgba(212, 164, 58, 0.15)' : 'var(--register-panel-soft)',
                      border: `1px solid ${eventsSelected.includes(opt) ? 'var(--register-gold)' : 'rgba(255, 255, 255, 0.1)'}`,
                      boxShadow: eventsSelected.includes(opt) ? '0 0 10px rgba(212, 164, 58, 0.2)' : 'none',
                      padding: '14px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                      fontFamily: `'Cinzel', serif`,
                      color: eventsSelected.includes(opt) ? 'var(--register-gold-soft)' : 'rgba(255,255,255,0.7)',
                      fontWeight: eventsSelected.includes(opt) ? 'bold' : 'normal'
                    }}
                    className="cyber-checkbox-label"
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '4px',
                      border: `2px solid ${eventsSelected.includes(opt) ? 'var(--register-gold)' : '#4a5568'}`,
                      marginRight: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: eventsSelected.includes(opt) ? 'var(--register-gold)' : 'transparent',
                      transition: 'all 0.2s'
                    }}>
                      {eventsSelected.includes(opt) && (
                        <svg viewBox="0 0 24 24" style={{ width: '14px', height: '14px', fill: 'none', stroke: '#000', strokeWidth: 3, strokeLinecap: 'round', strokeLinejoin: 'round' }}>
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      )}
                    </div>
                    <span style={{ fontSize: '0.95rem', letterSpacing: '1px' }}>{opt}</span>
                  </div>
                ))}
              </div>
            </div>

            <button 
              type="submit" 
              className="cert-btn primary"
              disabled={loading}
              style={{ width: '100%', marginTop: '10px' }}
            >
              {loading ? "SUBMITTING..." : "SUBMIT CLAIM"}
            </button>

            <div style={{ textAlign: 'center', marginTop: '25px' }}>
              <Link to="/certificate" style={{ color: 'var(--register-text)', textDecoration: 'underline', fontFamily: `'Alphakind', sans-serif`, fontSize: '1.1rem' }}>
                 Back to Certificate Download
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MissingRegistration;
